export const SERVICESKU = 'servicesku'
export const TIRESKU = 'tiresku'
export const FRONTTIRESKU = 'fronttire'
export const REARTIRESKU = 'reartire'

export const STAGGEREDPREFIX = {
  [FRONTTIRESKU]: 'FRONT',
  [REARTIRESKU]: 'REAR'
}
